export class TrainingCoursesReport {
    dateFrom:string=''
    dateTo:string=''
    
}
